<template>
  <div>
    <simple-page>
      <template v-slot:breadcrumb>
        <breadcrumb :items="breadcrumbItems" />
      </template>
      <template v-slot:pageTitle>
        <div class="infoRep-titleBtn">
          <a
            href="javascript:void(0);"
            class="infoadd-Btn"
            @click="
              $bvModal.show('repInfoRequestForm');
              row = null;
            "
            ><i class="fa fa-plus" aria-hidden="true"></i> New Request</a
          >
        </div>
        <button class="clear-search" @click="clearFilter" v-if="isEnrollPrime">Clear Search</button>
      </template>

      <template v-slot:filter v-if="isEnrollPrime">
        <div class="pending-underwriting-container">
          <form @submit.prevent="getAll(filters)">
            <div class="form-group row">
              <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                <label>Policy ID</label>
                <input
                    v-model="filters.policy_id"
                    type="text"
                    class="page-search-field"
                    placeholder="Enter Policy ID"
                />
              </div>
              <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                <label>Member Name</label>
                <input
                    v-model="filters.member_name"
                    type="text"
                    class="page-search-field"
                    placeholder="Enter Member Name"
                />
              </div>
              <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                <label>Status</label>
                <select
                    v-model="filters.status"
                    class="page-search-field"
                    placeholder="Select Status"
                >
                  <option value="">Select Status</option>
                  <option
                      v-for="(value, key) in statusList"
                      :key="key"
                      :value="key"
                  >
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row justify-content-md-end">
              <div class="col-xxl-2 col-xl-3">
                <button type="submit" class="univ-btn">Search</button>
              </div>
            </div>
          </form>
        </div>
      </template>


      <template v-slot:topPagination>
        <div class="top-pagination mb-3">
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
      </template>
      <template v-slot:table>
        <simple-table :columns="columns">
          <template v-slot:tableBody>
            <rep-info-request-table
              :rows.sync="rows"
              :colSpan="columns.length"
              @onRowOpen="openRowOpenModal"
              @onSuccess="getAll"
            />
          </template>
        </simple-table>
        <pagination :rows.sync="rows" :filters="filters" />
      </template>
    </simple-page>
    <rep-info-request-form @onSuccess="getAll" :row.sync="row" />
    <rep-info-request-cancel-modal :row.sync="row" @onSuccess="getAll" />
    <rep-info-request-detail-modal @onSuccess="getAll" :row.sync="row" />
    <rep-approve-modal  @onSuccess="getAll" :row.sync="row" />
    <rep-reject-modal  @onSuccess="getAll" :row.sync="row" />
    <rep-success-modal  @onSuccess="getAll" :row.sync="row" />
    <rep-request-failed  @onSuccess="getAll" :row.sync="row" />
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import RepInfoRequestTable from "@/views/RepInfoRequest/partials/RepInfoRequestTable.vue";
import RepInfoRequestForm from "@/views/RepInfoRequest/RepInfoRequestForm.vue";
import RepInfoRequestCancelModal from "./partials/RepInfoRequestCancelModal.vue";
import RepInfoRequestDetailModal from "./partials/RepInfoRequestDetailModal.vue";
import RepApproveModal from "./partials/RepApproveModal.vue";
import RepRejectModal from "./partials/RepRejectModal.vue";
import RepSuccessModal from "./partials/RepSuccessModal.vue";
import RepRequestFailed from "./partials/RepRequestFailed.vue"
import isEnrollPrimeUtil from "@/utils/isEnrollPrimeUtil";

const statusList = {
  pending: "Pending",
  in_progress: "In Progress",
  completed: "Completed",
  rejected: "Rejected",
  cancelled: "Cancelled",
};
export default {
  name: "RepInfoRequest",
  components: {
    RepInfoRequestTable,
    RepInfoRequestForm,
    RepInfoRequestCancelModal,
    RepInfoRequestDetailModal,
    RepApproveModal,
    RepSuccessModal,
    RepRequestFailed,
    RepRejectModal
  },
  data: () => ({
    rows: [],
    allColumns: [
    { label: "System ID" },
    { label: "Type" },
    { label: "Information" },
    { label: "Status" },
    { label: "Number of Card Requested" },
    { label: "Created At" },
    { label: "Action" },
  ],
    row: null,
    breadcrumbItems: [{ title: "Rep Information Requests", active: true }],
    filters: {
      policy_id: null,
      member_name: null,
      status: ""
    },
    statusList
  }),
  methods: {
    openRowOpenModal(row, type) {
      this.row = row;
      this.$nextTick(() => {
        this.$bvModal.show(type);
      });
    },
    getAll(filters = null) {
      let url;
      let loader = this.$loading.show();
      if (this.isEnrollPrime) {
        url = `v2/rep-info-request/enrollprime/list`;
      } else {
        url = `v2/rep-info-request/list`;
      }

      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url += `?${filterUrl}`;
      }

      Api.get(url)
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
    clearFilter() {
      this.filters = {
        policy_id: null,
        member_name: null,
        status: ""
      };
      this.getAll();
    },
  },
  computed:{
    isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    },
    columns() {
    return this.isEnrollPrime
      ? this.allColumns
      : this.allColumns.filter((item) => item.label !== "Number of Card Requested");
  },
  },
 
  created() {
    this.getAll();
  },
};
</script>
<style>
.infoRep-titleBtn {
  display: flex;
  align-items: center;
}
.infoRep-titleBtn h1 {
  margin-bottom: 0;
  margin-right: 15px;
}
.infoRep-titleBtn .infoadd-Btn {
  background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  padding: 8px 30px;
  outline: none;
}
.brand-color {
  color: #29bcff;
  font-weight: 600;
}
</style>
